module.exports = __webpack_public_path__ + "static/media/boat.ca90569b.jpg";